module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsEsiaConfirm-4a92c4501055344bfa4dfcf50fe91c94.png";